import React from "react";
import { format } from "date-fns";
import { Box } from "@mui/material";
import { Stack } from "@mui/material";

import { Comment } from "../../../../models/comment";

import useStyles from "../styles";

interface MessageProps {
  message: Comment;
  dateFormat?: string;
}

const LeftMessage = ({
  message,
  dateFormat = "dd/MM/yyyy hh:mm aa",
}: MessageProps) => {
  const classes = useStyles();

  return (
    <Box width="100%" display="flex" flexDirection="column">
      <Box
        className={classes.leftMessageBox}
        width="fit-content"
        maxWidth="50%"
      >
        <span data-cy="leftMessage">{message && message.message}</span>
      </Box>
      <Stack
        direction="row"
        alignItems="flex-end"
        justifyContent="flex-start"
        className="mt-1"
      >
        <span className={classes.messageTitle}>
          {message?.user?.name
            ? message.user.name
            : message.identifier
            ? message.identifier
            : ""}{" "}
        </span>
        <span className={classes.messageSubtitle}>
          {" "}
          -{" "}
          {message.createdAt
            ? format(new Date(message.createdAt), dateFormat)
            : ""}
        </span>
      </Stack>
    </Box>
  );
};

const RightMessage = ({
  message,
  dateFormat = "dd/MM/yyyy hh:mm aa",
}: MessageProps) => {
  const classes = useStyles();

  return (
    <Box width="100%" display="flex" flexDirection="column">
      <Box className={classes.rightMessageBox} maxWidth="50%">
        <span>{message && message.message}</span>
      </Box>
      <Stack
        direction="row"
        alignItems="flex-end"
        justifyContent="flex-end"
        className="mt-1"
      >
        <span className={classes.messageTitle}>
          {message?.user?.name
            ? message.user.name
            : message.identifier
            ? message.identifier
            : ""}
        </span>
        <span className={classes.messageSubtitle}>
          -{" "}
          {message.createdAt
            ? format(new Date(message.createdAt), dateFormat)
            : ""}
        </span>
      </Stack>
    </Box>
  );
};

export { RightMessage, LeftMessage };
